import React from 'react'
import PropTypes from 'prop-types'
import { browserHistory } from 'react-router'
import { List, ListItem } from 'material-ui/List'
import plural from '../../lib/plural'
import Poll from '../../models/Poll'
import timeSince from '../../lib/time'

const calcTotal = (results, pollId) =>
	(results[pollId] || []).reduce((t, n) => t + n, 0)

export default function PollsList({ polls, results }) {
	return (
		<List>
			{polls.map((poll) =>
				<ListItem
					key={poll.key}
					onClick={() => browserHistory.push(`/${poll.key}/results`)}
					primaryText={poll.question}
					secondaryText={
						<p className="secondary">
							<span>
								{plural(calcTotal(results, poll.key), 'vote')}
							</span>
							<span className="date">
								created {timeSince(poll.ts)} ago
							</span>
						</p>
					}
				/>
			)}
		</List>
	)
}

PollsList.propTypes = {
	polls: PropTypes.arrayOf(PropTypes.instanceOf(Poll)),
	results: PropTypes.object, // eslint-disable-line
}



// WEBPACK FOOTER //
// ./src/components/polls/List.jsx